import { Component, Input } from '@angular/core';
import { RefBatDto } from '../model/refbat.model';

@Component({
  selector: 'sibat-building-refbat',
  templateUrl: './building-refbat.component.html',
  styles: [],
})
export class BuildingRefbatComponent {
  @Input() refBatId: RefBatDto;
  constructor() {}
}
